import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import APP_FONT from '../../helpers/font';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
    width: 200,
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: APP_FONT,
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function CustomSelect({
  title, menuItems, handleChange, value, id, disabled,
}) {
  const classes = useStyles();
  return (
    <div>
      <FormControl className={classes.margin} disabled={disabled}>
        <InputLabel id={id}>{title}</InputLabel>
        <Select
          native
          labelId='customized-select-label'
          id={id}
          value={value || title}
          onChange={handleChange}
          input={<BootstrapInput />}
        >
          <option value='#78'>None</option>
          {menuItems}
        </Select>
      </FormControl>
    </div>
  );
}
